<template>
  <div :class="['appContainer', { delayedFadeIn: isLoggedIn }]">
    <AlertBar v-bind="alertBar" />
    <router-view />
  </div>
</template>

<script>
import AlertBar from '@/components/AlertBar';
import { mapState } from 'vuex';

export default {
  name: 'Main',

  components: {
    AlertBar,
  },

  computed: {
    ...mapState('app', ['alertBar']),
    ...mapState('auth', ['isLoggedIn']),
  },
};
</script>

<style lang="scss" scoped>
.appContainer {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  background-image: linear-gradient(to bottom, #fff 70%, darken(#fff, 10));
}
</style>
